import {
  DEFAULT_USER_PREFERENCES,
  normalizeUserPreferences,
  parseItemsPerPage,
} from './userPrefsDefaults';

let activePreferences = { ...DEFAULT_USER_PREFERENCES };

export function setRuntimeUserPreferences(preferences) {
  activePreferences = normalizeUserPreferences(preferences);
}

export function clearRuntimeUserPreferences() {
  activePreferences = { ...DEFAULT_USER_PREFERENCES };
}

export function getRuntimeUserPreferences() {
  return { ...activePreferences };
}

export function getRuntimeLocale() {
  return activePreferences.locale || DEFAULT_USER_PREFERENCES.locale;
}

export function getRuntimeDateFormat() {
  return activePreferences.dateFormat || DEFAULT_USER_PREFERENCES.dateFormat;
}

export function getRuntimeTimezone() {
  return activePreferences.timezone || DEFAULT_USER_PREFERENCES.timezone;
}

export function getRuntimePageSize() {
  return parseItemsPerPage(activePreferences.itemsPerPage);
}

export function getRuntimeTheme() {
  return activePreferences.theme || DEFAULT_USER_PREFERENCES.theme;
}
